export default __webpack_public_path__ + "static/media/lakhatasLakasfenntartas.a4ea2b07.png";